<div class="page-wrapper">
  <app-header></app-header>

  <div class="content-area" style="flex: 1;">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>
</div>
